export default "__VITE_ASSET__BgTRvOt4__"